import React from 'react';

class WelcomeBlock extends React.Component {
  constructor(props) {
    super(props);
  }
	render() {
    return (<div>
      <div className="rq-welcomeblock">
				<i className="fa fa-paw"></i>
        <h1>Please add <strong>a Block</strong></h1>
      </div>
		</div>);
	}
}
export default WelcomeBlock;



// WEBPACK FOOTER //
// ./assets/src/frontend/builder/welcomeBlock.js